import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'

import mapStateToProps from '../../store/mapStateToProps';
import mapDispatchToProps from '../../store/mapDispatchToProps';
import {hit} from '../metrics';
import ym from "react-yandex-metrika";

import $ from 'jquery';
import {Helmet} from 'react-helmet';
import SourcesMarketingForm from '../Sources/SourcesMarketingForm'

class SourcesAuditDesctope extends Component{

  state = {
    popup: false,
    smr: null
	}

	componentDidMount(){

		this.props.setPageId('sources-audit');
		$('body').addClass('page-sources tags-expanded hash-audit');
    window.scrollTo(0, 0);
    hit(window.location.pathname);
    window.addEventListener('scroll', this.scroll);

    window.gsap.registerPlugin(window.ScrollTrigger, window.ScrollSmoother);



    var lastScrollTop = 0;

    let smoother = window.ScrollSmoother.create({
      smooth: 1.2,
      effects: true,
      smoothTouch: true,
      normalizeScroll: true,
      onUpdate: e => {
        const y = e.scrollTop()

        if($('.hash-audit').length){
          if (y > lastScrollTop){
            $('body').removeClass('fixedd');
          }
          else {
            if(!$('body').hasClass("fixedd")){
              $('body').addClass('fixedd');
            }
          }
          lastScrollTop = y <= 0 ? 0 : y;
  
          $('body').removeClass('audit-bg')
          $('body').removeClass('audit-bg-footer')
          $('.audit-top').removeClass('active')
  
          if(y > 50){
            $('body').addClass('fixed');
          }
          else{
            $('body').removeClass('fixed');
          }
  
          if(y > 50 && y < window.innerHeight){
            $('body').addClass('audit-bg')
            $('.audit-top').addClass('active')
          }
  
          if(y >= window.innerHeight * 5.8 && y <= window.innerHeight * 8.5){
            $('body').addClass('audit-bg')
          }
  
          if(y >= $('.audit-recommend').offset().top){
            $('.audit-recommend').addClass('active')
          }
          else{
            $('.audit-recommend').removeClass('active')
          }
  
          if(y >= $('.audit-proff-title').offset().top){
            $('.audit-prof').addClass('active')
          }
          else{
            $('.audit-prof').removeClass('active')
          }
  
          if(y >= $('.audit-footer').offset().top){
            $('body').addClass('audit-bg-footer')
          }
        }
      }
    });

    this.setState({smr: smoother})

    /*window.ScrollTrigger.create({
      trigger: ".audit-top",
      pin: true,
      start: "bottom bottom",
      end: "+=" + window.innerHeight * 3,
    });*/

    window.ScrollTrigger.create({
      trigger: ".audit-second",
      pin: true,
      start: "bottom bottom",
      end: "+=" + window.innerHeight * 3,
    });

    /*window.ScrollTrigger.create({
      trigger: ".audit-recommend",
      pin: true,
      start: "bottom bottom",
      end: "+=" + window.innerHeight,
    });*/

    window.ScrollTrigger.create({
      trigger: ".audit-include",
      pin: true,
      start: "bottom bottom",
      end: "+=" + window.innerHeight * 2,
    });

    /*window.ScrollTrigger.create({
      trigger: ".audit-prof",
      pin: true,
      start: "bottom bottom",
      end: "+=" + window.innerHeight * 2,
    });

    window.ScrollTrigger.create({
      trigger: ".audit-footer",
      pin: true,
      start: "bottom bottom",
      end: "+=" + window.innerHeight,
    });*/

    let auditTop1 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-top',
        start: 0,
        end: window.innerHeight/4,
        scrub: 0.5,
      }
    });

    let auditTop2 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-top',
        start: window.innerHeight/4,
        end: window.innerHeight/3,
        scrub: 0.5,
      }
    });

    let auditTop3 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-top',
        start: window.innerHeight/3,
        end: window.innerHeight/2,
        scrub: 0.5,
      }
    });

    let auditTop4 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-top',
        start: window.innerHeight/2,
        end: window.innerHeight,
        scrub: 0.5,
      }
    });

    let auditTop5 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-top',
        start: window.innerHeight,
        end: window.innerHeight + window.innerHeight/4,
        scrub: 0.5,
      }
    });

    let auditTop6 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-top',
        start: window.innerHeight + window.innerHeight/4,
        end: window.innerHeight + window.innerHeight/3,
        scrub: 0.5,
      }
    });

    let auditSecond1 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-second',
        start: window.innerHeight/2,
        end: window.innerHeight,
        scrub: 0.5,
      }
    });

    let auditSecond2 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-second',
        start: window.innerHeight,
        end: window.innerHeight * 1.5,
        scrub: 0.5,
      }
    });

    let auditSecond3 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-second',
        start: window.innerHeight * 1.5,
        end: window.innerHeight * 2,
        scrub: 0.5,
      }
    });

    let auditSecond4 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-second',
        start: window.innerHeight * 2,
        end: window.innerHeight * 2.5,
        scrub: 0.5,
      }
    });

    let auditSecond5 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-second',
        start: window.innerHeight * 2.6,
        end: window.innerHeight * 3,
        scrub: 0.5,
      }
    });

    let auditRecommend = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-recommend',
        start: window.innerHeight * 8,
        end: window.innerHeight * 9,
        scrub: 0.5,
      }
    });

    let auditInclude1 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-include',
        start: window.innerHeight * 5.7,
        end: window.innerHeight * 6,
        scrub: 0.5,
      }
    });

    let auditInclude2 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-include',
        start: window.innerHeight * 6.2,
        end: window.innerHeight * 6.7,
        scrub: 0.5,
      }
    });

    let auditInclude3 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-include',
        start: window.innerHeight * 7,
        end: window.innerHeight * 7.5,
        scrub: 0.5,
      }
    });

    let auditProfTitle = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-prof-title',
        start: window.innerHeight * 14,
        end: window.innerHeight * 14.7,
        scrub: 0.5,
      }
    });

    
    let auditProf1 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-prof',
        start: window.innerHeight * 15.5,
        end: window.innerHeight * 15.8,
        scrub: 0.5,
      }
    });

    let auditProf2 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-prof',
        start: window.innerHeight * 15.8,
        end: window.innerHeight * 16.1,
        scrub: 0.5,
      }
    });

    let auditFooter = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.audit-footer',
        start: window.innerHeight * 18.5,
        end: window.innerHeight * 19,
        scrub: 0.5,
      }
    });

    /*auditTop1.to('.audit-top__dsc1', {opacity: 1, y : 0}, 0)
    auditTop2.to('.audit-top__in-title-wrap:nth-child(1) .audit-top__in-title:first-child', {opacity: 0}, 0)
    auditTop2.to('.audit-top__in-title-wrap:nth-child(1) .audit-top__in-title:last-child', {opacity: 1}, 0)
    auditTop3.to('.audit-top__in-title-wrap:nth-child(4) .audit-top__in-title:first-child', {opacity: 0}, 0)
    auditTop3.to('.audit-top__in-title-wrap:nth-child(4) .audit-top__in-title:last-child', {opacity: 1}, 0)
    auditTop4.to('.audit-top__in-title-wrap:nth-child(2) .audit-top__in-title:first-child', {opacity: 0}, 0)
    auditTop4.to('.audit-top__in-title-wrap:nth-child(2) .audit-top__in-title:last-child', {opacity: 1}, 0)
    auditTop5.to('.audit-top__in-title-wrap:nth-child(3) .audit-top__in-title:first-child', {opacity: 0}, 0)
    auditTop5.to('.audit-top__in-title-wrap:nth-child(3) .audit-top__in-title:last-child', {opacity: 1}, 0)
    auditTop6.to('.audit', {background: '#000'}, 0)
    auditTop6.to('.audit-top__dsc1', {color: '#fff'}, 0)

    auditTop6.to('.audit-circle4 div', {top: '17%', right: '10%'}, 0)
    auditTop6.to('.audit-circle3 div', {top: '87%', right: '15%'}, 0)
    auditTop6.to('.audit-circle2 div', {top: '21%', right: '9%'}, 0)
    auditTop6.to('.audit-circle1 div', {top: '91%', right: '20%'}, 0)*/

    //auditSecond1.to('.audit', {background: '#fff'}, 0)
    auditSecond1.to('.audit-second .audit-title', {color: '#000'}, 0)
    auditSecond2.to('.audit-circle3', {opacity: 1}, 0)
    auditSecond2.to('.audit-circle4 div', {top: '33%', right: '1%'}, 0)
    auditSecond3.to('.audit-circle4 div', {top: '49%', right: '-1.5%'}, 0)
    auditSecond3.to('.audit-circle3 div', {top: '94%', right: '25%'}, 0)
    auditSecond3.to('.audit-circle2', {opacity: 1}, 0)
    auditSecond4.to('.audit-circle1', {opacity: 1}, 0)
    auditSecond4.to('.audit-circle4 div', {top: '79%', right: '7.5%'}, 0)
    auditSecond4.to('.audit-circle3 div', {top: '99%', right: '45%'}, 0)
    auditSecond4.to('.audit-circle2 div', {top: '35%', right: '2%'}, 0)

    auditSecond5.to('.audit-circle4 div', {top: '92%', right: '21.5%'}, 0)
    auditSecond5.to('.audit-circle3 div', {top: '97%', right: '66%'}, 0)
    auditSecond5.to('.audit-circle2 div', {top: '56%', right: '0%'}, 0)
    auditSecond5.to('.audit-circle1 div', {top: '97%', right: '32%'}, 0)

    /*auditRecommend.to('.audit-recommend__box-first > div > div:first-child', {top: '-100%'}, 0)
    auditRecommend.to('.audit-recommend__box-first > div > div:last-child', {top: '-192%'}, 0)*/

    auditInclude1.to('.audit-include .audit-title', {color: '#fff'}, 0)
    //auditInclude1.to('.audit', {background: '#000'}, 0)
    auditInclude1.to('.audit-include__column div', {background: '#fff'}, 0)
    auditInclude1.to('.audit-include__column span', {color: '#000'}, 0)

    auditInclude2.to('.audit-include__column[data-id="1"]', {opacity: 0}, 0)
    auditInclude2.to('.audit-include__column-wrap[data-id="3"]', {width: '66.6%'}, 0)
    auditInclude2.to('.audit-include__column[data-id="7"]', {opacity: 1}, 0)

    auditInclude3.to('.audit-include__column-wrap[data-id="1"]', {width: '66.6%'}, 0)
    auditInclude3.to('.audit-include__column[data-id="4"]', {opacity: 1}, 0)
    auditInclude3.to('.audit-include__column-wrap[data-id="2"]', {width: '66.6%'}, 0)
    auditInclude3.to('.audit-include__column[data-id="8"]', {opacity: 1}, 0)

    /*auditProfTitle.to('.audit', {background: '#fff'}, 0)
    auditProfTitle.to('.audit-proff-title .audit-title', {color: '#000'}, 0)
    auditProfTitle.to('.audit-include__column div', {background: '#000'}, 0)
    auditProfTitle.to('.audit-include__column span', {color: '#fff'}, 0)
    auditProf1.to('.audit-prof__logos-row img[data-type="2"]', {opacity: 1}, 0)
    auditProf2.to('.audit-prof__logos-row img[data-type="3"]', {opacity: 1}, 0)

    auditFooter.to('.audit', {background: '#000'}, 0)
    auditFooter.to('.audit-footer__title', {color: '#fff'}, 0)
    auditFooter.to('.audit-footer__dsc', {color: '#fff'}, 0)*/
	}

	componentWillUnmount(){
		$('body').removeClass('page-sources tags-expanded hash-audit');
    $('body').removeClass('audit-bg')
    $('body').removeClass('audit-bg-footer')
	}

	render(){

		return(
      <Fragment>
        <div className={this.state.popup ? 'contacts-call-me-popup active' : 'contacts-call-me-popup'}>
          <div><SourcesMarketingForm close={() => this.setState({popup: false})} /></div>

          <div className="contacts-call-me-popup__close" onClick={() => this.setState({popup: false})}></div>
        </div>
        <div id="smooth-wrapper" className="audit-smooth-wrapper">
          <div id="smooth-content">
            <Helmet>
              <title>Аудит контекстной рекламы: найдём потери бюджета | Amio</title>
              <meta name="description" content="Проводим аудит контекстной рекламы в Яндекс Директе и Google Ads: находим слив бюджета, ошибки в настройках и точки роста. Получите отчёт и план действий." />
            </Helmet>
            <div className="audit">

              <div className="audit-top">
                <div className="audit-top__in">
                  <div>
                    <div className="audit-top__in-title-wrap">
                      <div className="audit-top__in-title">Аудит</div>
                      <div className="audit-top__in-title blue">Аудит</div>
                    </div>
                    <div className="audit-top__in-title-wrap">
                      <div className="audit-top__in-title">контекстной<br />рекламы</div>
                      <div className="audit-top__in-title white">контекстной<br />рекламы</div>
                    </div>
                    <div className="audit-top__in-title-wrap">
                      <div className="audit-top__in-title">от экспертов</div>
                      <div className="audit-top__in-title orange"><span>от</span> экспертов</div>
                    </div>
                    <div className="audit-top__in-title-wrap">
                      <div className="audit-top__in-title">рынка<br />недвижимости</div>
                      <div className="audit-top__in-title green">рынка<br />недвижимости</div>
                    </div>
                  </div>
                  <div>
                    <div className="audit-top__dsc1">
                      Наши специалисты — настоящие профессионалы своего дела, которые не только знают как правильно настраивать контекстную рекламу, но и обучают этому рынок.
                    </div>
                    <div className="audit-top__dsc2">
                      С соблюдением строгих норм конфиденциальности мы составим для вас подробный аудит с рекомендациями, которые помогут вам увеличить отдачу от рекламы.
                    </div>
                  </div>
                </div>
              </div>

              <div className="audit-second">
                <div>
                  <div className="audit-title">
                    Знаем как улучшить<br />
                    ваши рекламные компании<br />
                    :
                  </div>

                  <div className="audit-circles">
                    <div className="audit-circle1">
                      Найдем способы снизить<br />стоимость обращения
                      <div></div>
                    </div>
                    <div className="audit-circle2">
                      Порекомендуем,<br />
                      как повысить<br />
                      количество звонков
                      <div></div>
                    </div>
                    <div className="audit-circle3">
                      Укажем на ошибки<br />и точки роста
                      <div></div>
                    </div>
                    <div className="audit-circle4">
                      Дадим объективную оценку<br />вашей текущей РК
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="audit-recommend">
                <div>
                  <div className="audit-title">
                    После внедрения<br />
                    наших рекомендаций<br />
                    вы получаете<br />
                    :
                  </div>

                  <div className="audit-recommend__box">
                    <div>
                      <div className="audit-recommend__box-first">
                        <svg width="67" height="149" viewBox="0 0 67 149" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M29.4426 32.4V57H37.6426V32.4H59.9426V24.6H37.6426V-5.24521e-06H29.4426V24.6H7.04258V32.4H29.4426ZM15.3652 104.8C23.5652 104.8 30.6652 98.3 30.6652 90C30.6652 81.5 23.6652 75.2 15.3652 75.2C7.06523 75.2 0.265235 81.6 0.265235 90C0.265235 98.4 7.06523 104.8 15.3652 104.8ZM15.3652 97.4C11.2652 97.4 8.06523 94.1 8.06523 90C8.06523 85.9 11.1652 82.5 15.3652 82.5C19.5652 82.5 22.8652 85.8 22.8652 90C22.8652 94.2 19.5652 97.4 15.3652 97.4ZM11.2652 147L65.2652 76.4H55.8652L1.76523 147H11.2652ZM36.5652 133.5C36.5652 141.9 43.3652 148.2 51.6652 148.2C59.9652 148.2 66.8652 141.9 66.8652 133.5C66.8652 125 60.0652 118.6 51.6652 118.6C43.2652 118.6 36.5652 125 36.5652 133.5ZM44.3652 133.4C44.3652 129.3 47.4652 125.9 51.6652 125.9C55.8652 125.9 59.0652 129.2 59.0652 133.4C59.0652 137.6 55.8652 140.8 51.6652 140.8C47.5652 140.8 44.3652 137.5 44.3652 133.4Z" fill="black"/>
                        </svg>
                        <div>
                          <div>
                            <span>7</span>
                            <span>8</span>
                            <span>9</span>
                            <span>0</span>
                            <span>1</span>
                          </div>
                          <div>
                            <span>4</span>
                            <span>5</span>
                            <span>6</span>
                            <span>7</span>
                          </div>
                        </div>
                      </div>

                      Больше звонков /заявок:<br />
                      в среднем +17%
                    </div>
                    <div>
                      <div className="audit-recommend__box-first">
                        <svg width="67" height="135" viewBox="0 0 67 135" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M59.7527 8.4V0.6H7.25273V8.4H59.7527ZM15.3652 90.8C23.5652 90.8 30.6652 84.3 30.6652 76C30.6652 67.5 23.6652 61.2 15.3652 61.2C7.06523 61.2 0.265235 67.6 0.265235 76C0.265235 84.4 7.06523 90.8 15.3652 90.8ZM15.3652 83.4C11.2652 83.4 8.06523 80.1 8.06523 76C8.06523 71.9 11.1652 68.5 15.3652 68.5C19.5652 68.5 22.8652 71.8 22.8652 76C22.8652 80.2 19.5652 83.4 15.3652 83.4ZM11.2652 133L65.2652 62.4H55.8652L1.76523 133H11.2652ZM36.5652 119.5C36.5652 127.9 43.3652 134.2 51.6652 134.2C59.9652 134.2 66.8652 127.9 66.8652 119.5C66.8652 111 60.0652 104.6 51.6652 104.6C43.2652 104.6 36.5652 111 36.5652 119.5ZM44.3652 119.4C44.3652 115.3 47.4652 111.9 51.6652 111.9C55.8652 111.9 59.0652 115.2 59.0652 119.4C59.0652 123.6 55.8652 126.8 51.6652 126.8C47.5652 126.8 44.3652 123.5 44.3652 119.4Z" fill="black"/>
                        </svg>

                        <div>
                          <div>
                            <span>5</span>
                            <span>4</span>
                            <span>3</span>
                            <span>2</span>
                            <span>1</span>
                          </div>
                          <div>
                            <span>2</span>
                            <span>3</span>
                            <span>4</span>
                            <span>5</span>
                          </div>
                        </div>
                      </div>

                      Ниже цену обращения:<br />
                      в среднем -15%
                    </div>
                    <div>
                      <svg width="276" height="223" viewBox="0 0 276 223" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M28.625 87V14.125C25.9583 16.375 21.9583 18.7917 16.625 21.375V17C19.7083 14.3333 22.375 11.625 24.625 8.875C26.875 6.125 28.7083 3.33333 30.125 0.499996H32.375C33.7917 3.33333 35.625 6.125 37.875 8.875C40.125 11.625 42.7917 14.3333 45.875 17V21.375C43.2917 20.125 41 18.9167 39 17.75C37 16.5 35.2917 15.2917 33.875 14.125V87H28.625Z" fill="black"/>
                        <path d="M142.1 69.7L142.816 70.3977L143.406 69.7922L142.907 69.1098L142.1 69.7ZM135.3 60.4L136.107 59.8098L135.424 58.8754L134.599 59.6871L135.3 60.4ZM134 27.1L133.354 27.8634L134.223 28.5984L134.84 27.6425L134 27.1ZM140.2 17.5L141.04 18.0425L141.485 17.3534L140.896 16.7823L140.2 17.5ZM76.5 44.2C76.5 55.2837 80.309 64.7954 86.9631 71.5398C93.6187 78.2857 103.059 82.2 114.2 82.2V80.2C103.541 80.2 94.6313 76.4643 88.3869 70.1352C82.141 63.8046 78.5 54.8163 78.5 44.2H76.5ZM114.2 82.2C125.557 82.2 135.119 78.3003 142.816 70.3977L141.384 69.0023C134.081 76.4997 125.043 80.2 114.2 80.2V82.2ZM142.907 69.1098L136.107 59.8098L134.493 60.9902L141.293 70.2902L142.907 69.1098ZM134.599 59.6871C128.662 65.5269 122.006 68.4 114.7 68.4V70.4C122.594 70.4 129.738 67.2731 136.001 61.1129L134.599 59.6871ZM114.7 68.4C107.621 68.4 101.919 65.7108 97.9792 61.3542C94.0297 56.9871 91.8 50.8866 91.8 44H89.8C89.8 51.3134 92.1703 57.9128 96.4958 62.6958C100.831 67.4892 107.079 70.4 114.7 70.4V68.4ZM91.8 44C91.8 37.014 94.0286 31.1765 97.9466 27.0923C101.86 23.0129 107.537 20.6 114.6 20.6V18.6C107.063 18.6 100.84 21.1871 96.5034 25.7077C92.1714 30.2235 89.8 36.586 89.8 44H91.8ZM114.6 20.6C121.227 20.6 128.305 23.5907 133.354 27.8634L134.646 26.3366C129.295 21.8093 121.773 18.6 114.6 18.6V20.6ZM134.84 27.6425L141.04 18.0425L139.36 16.9575L133.16 26.5575L134.84 27.6425ZM140.896 16.7823C133.979 10.0713 125.014 6.79999 114 6.79999V8.79999C124.586 8.79999 133.021 11.9287 139.504 18.2177L140.896 16.7823ZM114 6.79999C92.3514 6.79999 76.5 22.5441 76.5 44.2H78.5C78.5 23.6559 93.4486 8.79999 114 8.79999V6.79999ZM181.082 80V81H182.082V80H181.082ZM181.082 20.1V19.1H180.082V20.1H181.082ZM204.382 20.1V21.1H205.382V20.1H204.382ZM204.382 9H205.382V8H204.382V9ZM144.982 9V8H143.982V9H144.982ZM144.982 20.1H143.982V21.1H144.982V20.1ZM168.282 20.1H169.282V19.1H168.282V20.1ZM168.282 80H167.282V81H168.282V80ZM182.082 80V20.1H180.082V80H182.082ZM181.082 21.1H204.382V19.1H181.082V21.1ZM205.382 20.1V9H203.382V20.1H205.382ZM204.382 8H144.982V10H204.382V8ZM143.982 9V20.1H145.982V9H143.982ZM144.982 21.1H168.282V19.1H144.982V21.1ZM167.282 20.1V80H169.282V20.1H167.282ZM168.282 81H181.082V79H168.282V81ZM226.289 80V81H227.289V80H226.289ZM226.289 53.5V52.5H225.289V53.5H226.289ZM238.689 53.5L239.573 53.0329L239.292 52.5H238.689V53.5ZM252.689 80L251.805 80.4671L252.086 81H252.689V80ZM267.189 80V81H268.885L268.064 79.516L267.189 80ZM252.589 53.6L251.705 54.0679L251.71 54.076L251.714 54.084L252.589 53.6ZM250.289 49.9H249.289V50.2699L249.53 50.5508L250.289 49.9ZM250.289 49.7L249.91 48.7748L249.289 49.0294V49.7H250.289ZM258.989 18.2L258.143 18.7328L258.145 18.7369L258.989 18.2ZM213.389 9V8H212.389V9H213.389ZM213.389 80H212.389V81H213.389V80ZM226.289 20.1V19.1H225.289V20.1H226.289ZM226.289 42.3H225.289V43.3H226.289V42.3ZM227.289 80V53.5H225.289V80H227.289ZM226.289 54.5H238.689V52.5H226.289V54.5ZM237.805 53.9671L251.805 80.4671L253.573 79.5329L239.573 53.0329L237.805 53.9671ZM252.689 81H267.189V79H252.689V81ZM268.064 79.516L253.464 53.116L251.714 54.084L266.314 80.484L268.064 79.516ZM253.473 53.1321C252.57 51.4272 251.727 50.0406 251.048 49.2492L249.53 50.5508C250.051 51.1594 250.808 52.3728 251.705 54.0679L253.473 53.1321ZM251.289 49.9V49.7H249.289V49.9H251.289ZM250.669 50.6252C258.934 47.2342 263.189 38.6985 263.189 30.3H261.189C261.189 38.1015 257.244 45.7658 249.91 48.7748L250.669 50.6252ZM263.189 30.3C263.189 25.4444 262.052 21.1504 259.833 17.6631L258.145 18.7369C260.126 21.8496 261.189 25.7556 261.189 30.3H263.189ZM259.835 17.6672C254.431 9.08444 245.618 8 236.789 8V10C245.56 10 253.347 11.1155 258.143 18.7328L259.835 17.6672ZM236.789 8H213.389V10H236.789V8ZM212.389 9V80H214.389V9H212.389ZM213.389 81H226.289V79H213.389V81ZM226.289 21.1H235.689V19.1H226.289V21.1ZM235.689 21.1C239.393 21.1 242.49 21.6028 244.646 23.0439C246.715 24.4271 248.089 26.7967 248.089 31H250.089C250.089 26.3033 248.513 23.2229 245.757 21.3811C243.088 19.5972 239.485 19.1 235.689 19.1V21.1ZM248.089 31C248.089 34.2405 247.083 36.7945 245.365 38.5349C243.648 40.2738 241.122 41.3 237.889 41.3V43.3C241.556 43.3 244.63 42.1262 246.788 39.9401C248.945 37.7555 250.089 34.6595 250.089 31H248.089ZM237.889 41.3H226.289V43.3H237.889V41.3ZM227.289 42.3V20.1H225.289V42.3H227.289Z" fill="black"/>
                        <path d="M28.625 114V186.875C25.9583 184.625 21.9583 182.208 16.625 179.625V184C19.7083 186.667 22.375 189.375 24.625 192.125C26.875 194.875 28.7083 197.667 30.125 200.5H32.375C33.7917 197.667 35.625 194.875 37.875 192.125C40.125 189.375 42.7917 186.667 45.875 184V179.625C43.2917 180.875 41 182.083 39 183.25C37 184.5 35.2917 185.708 33.875 186.875V114H28.625Z" fill="black"/>
                        <path d="M142.1 189.7L142.816 190.398L143.406 189.792L142.907 189.11L142.1 189.7ZM135.3 180.4L136.107 179.81L135.424 178.875L134.599 179.687L135.3 180.4ZM134 147.1L133.354 147.863L134.223 148.598L134.84 147.643L134 147.1ZM140.2 137.5L141.04 138.043L141.485 137.353L140.896 136.782L140.2 137.5ZM76.5 164.2C76.5 175.284 80.309 184.795 86.9631 191.54C93.6187 198.286 103.059 202.2 114.2 202.2V200.2C103.541 200.2 94.6313 196.464 88.3869 190.135C82.141 183.805 78.5 174.816 78.5 164.2H76.5ZM114.2 202.2C125.557 202.2 135.119 198.3 142.816 190.398L141.384 189.002C134.081 196.5 125.043 200.2 114.2 200.2V202.2ZM142.907 189.11L136.107 179.81L134.493 180.99L141.293 190.29L142.907 189.11ZM134.599 179.687C128.662 185.527 122.006 188.4 114.7 188.4V190.4C122.594 190.4 129.738 187.273 136.001 181.113L134.599 179.687ZM114.7 188.4C107.621 188.4 101.919 185.711 97.9792 181.354C94.0297 176.987 91.8 170.887 91.8 164H89.8C89.8 171.313 92.1703 177.913 96.4958 182.696C100.831 187.489 107.079 190.4 114.7 190.4V188.4ZM91.8 164C91.8 157.014 94.0286 151.177 97.9466 147.092C101.86 143.013 107.537 140.6 114.6 140.6V138.6C107.063 138.6 100.84 141.187 96.5034 145.708C92.1714 150.223 89.8 156.586 89.8 164H91.8ZM114.6 140.6C121.227 140.6 128.305 143.591 133.354 147.863L134.646 146.337C129.295 141.809 121.773 138.6 114.6 138.6V140.6ZM134.84 147.643L141.04 138.043L139.36 136.957L133.16 146.557L134.84 147.643ZM140.896 136.782C133.979 130.071 125.014 126.8 114 126.8V128.8C124.586 128.8 133.021 131.929 139.504 138.218L140.896 136.782ZM114 126.8C92.3514 126.8 76.5 142.544 76.5 164.2H78.5C78.5 143.656 93.4486 128.8 114 128.8V126.8ZM165.082 200V201H166.082V200H165.082ZM165.082 175.5V174.5H164.082V175.5H165.082ZM152.182 129V128H151.182V129H152.182ZM152.182 200H151.182V201H152.182V200ZM165.082 140.1V139.1H164.082V140.1H165.082ZM165.082 164.3H164.082V165.3H165.082V164.3ZM166.082 200V175.5H164.082V200H166.082ZM165.082 176.5H179.582V174.5H165.082V176.5ZM179.582 176.5C186.687 176.5 192.607 173.901 196.747 169.511C200.881 165.128 203.182 159.022 203.182 152.1H201.182C201.182 158.578 199.033 164.172 195.292 168.139C191.557 172.099 186.177 174.5 179.582 174.5V176.5ZM203.182 152.1C203.182 145.128 200.881 139.093 196.74 134.794C192.595 130.491 186.675 128 179.582 128V130C186.189 130 191.569 132.309 195.299 136.181C199.033 140.057 201.182 145.572 201.182 152.1H203.182ZM179.582 128H152.182V130H179.582V128ZM151.182 129V200H153.182V129H151.182ZM152.182 201H165.082V199H152.182V201ZM165.082 141.1H177.382V139.1H165.082V141.1ZM177.382 141.1C180.865 141.1 183.509 142.2 185.285 144.054C187.067 145.914 188.082 148.644 188.082 152.1H190.082C190.082 148.256 188.947 144.986 186.729 142.671C184.505 140.35 181.299 139.1 177.382 139.1V141.1ZM188.082 152.1C188.082 155.662 187.063 158.439 185.26 160.32C183.463 162.195 180.772 163.3 177.182 163.3V165.3C181.192 165.3 184.451 164.055 186.704 161.704C188.951 159.361 190.082 156.037 190.082 152.1H188.082ZM177.182 163.3H165.082V165.3H177.182V163.3ZM166.082 164.3V140.1H164.082V164.3H166.082ZM273.205 189.7L273.922 190.398L274.512 189.792L274.013 189.11L273.205 189.7ZM266.405 180.4L267.213 179.81L266.529 178.875L265.704 179.687L266.405 180.4ZM265.105 147.1L264.46 147.863L265.328 148.598L265.946 147.643L265.105 147.1ZM271.305 137.5L272.146 138.043L272.591 137.353L272.002 136.782L271.305 137.5ZM207.605 164.2C207.605 175.284 211.414 184.795 218.069 191.54C224.724 198.286 234.164 202.2 245.305 202.2V200.2C234.647 200.2 225.737 196.464 219.492 190.135C213.247 183.805 209.605 174.816 209.605 164.2H207.605ZM245.305 202.2C256.662 202.2 266.225 198.3 273.922 190.398L272.489 189.002C265.186 196.5 256.149 200.2 245.305 200.2V202.2ZM274.013 189.11L267.213 179.81L265.598 180.99L272.398 190.29L274.013 189.11ZM265.704 179.687C259.767 185.527 253.111 188.4 245.805 188.4V190.4C253.7 190.4 260.844 187.273 267.107 181.113L265.704 179.687ZM245.805 188.4C238.726 188.4 233.025 185.711 229.085 181.354C225.135 176.987 222.905 170.887 222.905 164H220.905C220.905 171.313 223.276 177.913 227.601 182.696C231.936 187.489 238.185 190.4 245.805 190.4V188.4ZM222.905 164C222.905 157.014 225.134 151.177 229.052 147.092C232.965 143.013 238.643 140.6 245.705 140.6V138.6C238.168 138.6 231.946 141.187 227.609 145.708C223.277 150.223 220.905 156.586 220.905 164H222.905ZM245.705 140.6C252.332 140.6 259.41 143.591 264.46 147.863L265.751 146.337C260.401 141.809 252.879 138.6 245.705 138.6V140.6ZM265.946 147.643L272.146 138.043L270.465 136.957L264.265 146.557L265.946 147.643ZM272.002 136.782C265.084 130.071 256.119 126.8 245.105 126.8V128.8C255.692 128.8 264.127 131.929 270.609 138.218L272.002 136.782ZM245.105 126.8C223.457 126.8 207.605 142.544 207.605 164.2H209.605C209.605 143.656 224.554 128.8 245.105 128.8V126.8Z" fill="black"/>
                      </svg>

                      Дополнительные результаты:<br />
                      рост CTR, снижение CPC.
                    </div>
                  </div>
                </div>
              </div>

              <div className="audit-include">
                <div>
                  <div className="audit-title">
                    Аудит включает <sup><small>(50+ параметров)</small></sup><br />
                    :
                  </div>

                  <div className="audit-include__rows">
                    <div>
                      <div className="audit-include__column" data-id="1">
                        <span>Проверку корректности<br />используемой семантики</span>
                        <div></div>
                      </div>

                      <div className="audit-include__column" data-id="4">
                        <span>Проверку корректности<br />используемой семантики</span>
                        <div></div>
                      </div>

                      <div className="audit-include__column-wrap" data-id="1">
                        <div className="audit-include__column" data-id="2">
                          <span>Оценку эффективности каналов,<br />кампаний, таргетингов</span>
                          <div></div>
                        </div>
                        <div className="audit-include__column" data-id="3">
                          <span>Анализ структуры<br />и настроек кампаний</span>
                          <div></div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="audit-include__column-wrap" data-id="2">
                        <div className="audit-include__column-wrap" data-id="3">
                          <div className="audit-include__column" data-id="5">
                            <span>Оценку подхода к установке<br />ставок / стратегий</span>
                            <div></div>
                          </div>
                          <div className="audit-include__column" data-id="6">
                            <span>Проверку интеграции<br />со счетчиками,<br /> настройку целей<br /> в системах аналитики</span>
                            <div></div>
                          </div>
                        </div>

                        <div className="audit-include__column" data-id="7">
                          <span>Краткий анализ<br />юзабилити сайта</span>
                          <div></div>
                        </div>
                      </div>

                      <div className="audit-include__column" data-id="8">
                        <span>Рекомендации<br />по увеличению<br />эффективности<br />и дополнительного<br />охвата ЦА</span>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="audit-proff-title">
                <div className="audit-title">Доказанный<br />профессионализм</div>
              </div>

              <div className="audit-prof">
                <div>
                  <div className="audit-prof__top">
                    <div>
                      <img src="/sources/img/audit/prof.png" />
                    </div>
                    <div>
                      <div className="audit-prof__top-txt">
                        <div>Digital-директор<br />Кристина Бессмертная</div>
                        <p>Эксперт Яндекса по обучению Яндекс Директ и Яндекс Метрика, обучила более 1000 студентов в Geekbrains, имеет опыт работы в сфере недвижимости, e-commerce, авто, фарма, пр., точно знает как настроить рекламу так, чтобы она работала максимально эффективно.</p>
                      </div>
                    </div>
                  </div>

                  <div className="audit-prof__logos">
                    <div className="audit-prof__logos-row">
                      <img src="/sources/img/audit/audit_logo1.png" data-id="1" />
                      <img src="/sources/img/audit/audit_logo2.png" data-id="2" data-type="2" />
                      <img src="/sources/img/audit/audit_logo3.png" data-id="3" data-type="3" />
                    </div>
                    <div className="audit-prof__logos-row">
                      <img src="/sources/img/audit/audit_logo4.png" data-id="4" data-type="3" />
                      <img src="/sources/img/audit/audit_logo5.png" data-id="5" data-type="2" />
                      <img src="/sources/img/audit/audit_logo6.png" data-id="6" data-type="3" />
                      <img src="/sources/img/audit/audit_logo7.png" data-id="7" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="audit-footer">
                <div>
                  <div className="audit-footer__title">
                    <span
                      onClick={() => {
                        if (this.state.smr) {
                          this.state.smr.scrollTo(".marketing-footer-wrap", true, "center center")
                        }
                      }}
                    >
                      Закажите
                      </span> аудит вашей<br />контекстной рекламы</div>
                  <div className="audit-footer__dsc">Смотрите также: <Link to="/accents/marketing/">Маркетинг в недвижимости</Link></div>
                </div>
              </div>

              <div className="marketing-footer-wrap">
                <section className="marketing-footer-new">
                  <div className="marketing-footer-new__in">
                    <div>
                      <div>
                        Приглашаем <br />в гости
                      </div>
                      <Link
                        to="/contacts"
                        onClick={() => {
                          ym("reachGoal", "click_on_guests");
                          return true;
                        }}
                      >
                        Мы рядом
                      </Link>
                    </div>
                    <div>
                      <div>
                        Ждём <br />
                        звонка
                      </div>
                      <a
                        href="tel: +7 (495) 921-41-70"
                        onClick={() => {
                          ym("reachGoal", "click_on_call_me");
                          return true;
                        }}
                      >
                        +7 (495) 921-41-70
                      </a>
                    </div>
                    <div>
                      <div>
                        Перезвоним <br />
                        сами
                      </div>
                      <span
                        onClick={() => {
                          this.setState({popup: true})
                          ym("reachGoal", "click_on_callback");
                          return true;
                        }}
                      >
                        Быстро
                      </span>
                    </div>
                  </div>
                </section>
              </div>

            </div>
          </div>
        </div>
      </Fragment>
		)
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SourcesAuditDesctope)